<template>
  <div class="login-box">
    <div class="login-logo">
      <a href>
        <b>ProCheck</b> CMS
      </a>
    </div>
    <div class="login-box-body">
      <p class="login-box-msg"></p>
      <el-form @keydown.native.enter="sendForm">
        <el-form-item required >
          <label><b class="field-required">รหัสผ่าน</b>
            <el-tooltip content="ต้องมีอักษร A-Z, a-z, 0-9 และไม่น้อยกว่า 8 ตัวขึ้นไป แต่ไม่เกิน 25 ตัว" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </label>
          <el-input v-model="password" ref="password" placeholder="รหัสผ่าน" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item required>
          <label><b class="field-required">ยืนยันรหัสผ่าน</b></label>
          <el-input v-model="confirm_password" ref="confirm_password" placeholder="ยืนยันรหัสผ่าน" type="password" show-password></el-input>
        </el-form-item>
        <div class="row">
          <div class="col-xs-12">
            <button type="button" class="btn btn-primary btn-block btn-flat"  @click.prevent="sendForm">ยืนยัน</button>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<style>
.skin-blue.sidebar-mini {
  background-color: rgb(210, 214, 222);
}
.login-box-body.register-box-body {
  padding: 20px;
  color: #666;
  background: #fff;
  border-top: 0;
}
.checkbox.radio {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}
.content-cookies2f {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #f5f5f5;
    z-index: 2000;
    width: 100%;
    padding: 20px 0;
    box-shadow: 0 0 10px #ccc;
    -webkit-box-shadow: 0 0 10px #ccc;
    -moz-box-shadow: 0 0 10px #ccc;
    -o-box-shadow: 0 0 10px #ccc;
}
.box-cookies2f {
    position: relative;
    padding-right: 150px;
}
.content-cookies2f .btn-purple {
    width: auto;
    min-width: 120px;
    height: auto;
    /* padding: 5px 15px; */
    font-size: 14px;
    position: absolute;
    right: 0;
    top: 0;
}
.field-required:after {
  content: '*';
  color: #f56c6c;
  margin-left: 4px;
}
</style>
<script>
import { mapState, mapActions } from 'vuex';
export default {
  data(){
    return{
      password: '',
      confirm_password: ''
    }
  },
  created() {},
  computed: {
    ...mapState({})
  },
  mounted() {
      console.log(this.$route.params)
  },
  methods:{
    ...mapActions({
      reset_password:'Login_store/reset_password'
    }),
    sendForm(){
        if (this.password == "") {
            this.$alert("กรุณาระบุรหัสผ่าน", "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                type: "warning",
                callback: action => {
                    this.$refs.password.focus();
                }
            });
        } else if (this.confirm_password == "") {
            this.$alert("กรุณาระบุยืนยันรหัสผ่าน", "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                type: "warning",
                callback: action => {
                    this.$refs.confirm_password.focus();
                }
            });
        } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[^A-z0-9]).{8,25}/.test(this.password)) {
            this.$alert("รูปแบบรหัสผ่านไม่ถูกต้อง", "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                type: "warning",
                callback: action => {
                    this.$refs.password.focus();
                }
            });
        } else if (this.password != this.confirm_password) {
            this.$alert("รหัสผ่านและยืนยันรหัสผ่าน ไม่ตรงกัน", "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                type: "warning",
                callback: action => {
                    this.$refs.confirm_password.focus();
                }
            });
        } else {
            let password_data = {
                password: this.password,
                confirm_password: this.confirm_password
            }
            if (this.$route.params.forgot_token) {
                password_data.forgot_token = this.$route.params.forgot_token
            } else if (this.$route.params.activate_token) {
                password_data.activate_token = this.$route.params.activate_token
            }
            this.reset_password(password_data)
        }
        
    }
  }
}
</script>



